import { isEqual } from 'lodash'; // Importe a função isEqual se ainda não o fez
import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { type AppDispatch, type RootState, useAppDispatch } from '../store';
import { type EjnFilter, setFilters } from '../store/reducers/ejn-filters';
import { setTab } from '../store/reducers/ejn-toogle';
import type { NotificationStatus } from '../types';

const tabsMapper: Record<string, NotificationStatus[]> = {
  PENDING_DECISION: ['PENDING_DECISION'],
  PENDING_RESULT: ['PENDING_RESULT'],
  OTHER: ['PENDING_SEND', 'SEND_PROTEST', 'CANCELED', 'DONE'],
};

export const useEjnSelectedTab = () => {
  const { notificationStatuses } = useSelector(
    (state: RootState) => state.extrajudicialNotificationsFiltersStore,
  );

  const { selectedTab } = useSelector(
    (state: RootState) => state.extrajudicialNotificationsToogleStore,
  );

  const dispatch: AppDispatch = useAppDispatch();

  const handleChange = useCallback(
    (filter: Partial<EjnFilter>) => {
      dispatch(setFilters(filter));
    },
    [dispatch],
  );

  const setSelectedTab = (value: string) => dispatch(setTab(value));

  useEffect(() => {
    if (!isEqual(tabsMapper[selectedTab], notificationStatuses)) {
      handleChange({ notificationStatuses: [...tabsMapper[selectedTab]] });
    }
  }, [selectedTab, handleChange, notificationStatuses]);

  return { selectedTab, setSelectedTab, tabsMapper };
};
